import {Component, Input, OnInit} from '@angular/core';
import {KennzahlDTO} from '@rsp/models/dto/kennzahl.dto';
import {KennzahlenDayMonthYearEnum} from '@rsp/models/enum/kennzahlen-day-month-year.enum';
import {getStartOfMonth, getStartOfYear} from '@rsp/shared/util/util';


@Component({
  selector: 'rsp-kennzahl',
  templateUrl: './kennzahl.component.html',
  styleUrls: ['./kennzahl.component.scss']
})
export class KennzahlComponent implements OnInit {


  @Input() public small: boolean;

  private _kennzahlen: KennzahlDTO[] = [];

  public get kennzahlen(): KennzahlDTO[] {
    return this._kennzahlen;
  }

  public dayMonthYearIndex: number;

  public startDate: Date;
  public endDate: Date;

  @Input()
  public set kennzahlen(value: KennzahlDTO[]) {
    this._kennzahlen = value;
    this.calcInformations();
  }

  constructor() {
    this.dayMonthYearIndex = 0;

    this.startDate = new Date();
    this.endDate = new Date();
  }

  ngOnInit(): void {

  }


  public switchKennzahl() {
    this.dayMonthYearIndex = (this.dayMonthYearIndex + 1) % 3;
    this.calcInformations();
  }

  public calcInformations() {
    if (this.dayMonthYearIndex === KennzahlenDayMonthYearEnum.DAY) {
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 1);
    } else if (this.dayMonthYearIndex === KennzahlenDayMonthYearEnum.MONTH) {
      this.startDate = getStartOfMonth(new Date());
      this.endDate = new Date();
      this.endDate.setDate(this.endDate.getDate() - 1);
    } else {
      this.startDate = getStartOfYear(new Date());
      this.endDate = new Date();
      this.endDate.setDate(this.endDate.getDate() - 1);
    }
  }

}
